import { Stack, Heading, Grid } from '@global-ecom/nitro-uds/elements';

import { SanityImage } from '__generated__/graphql';
import { useProductClickHandling } from 'hooks/useProductClickHandling';

import { LaunchCalendarTile } from './LaunchCalendarTile';

export type LaunchCalendarItem = {
  productImage?: SanityImage;
  color: string;
  launchDate: string;
  masterId: string;
  productId: string;
  productName: string;
  launchCalendarProductName: string;
  launchCopy?: string;
  ctaCopy?: string;
  imageView?: string;
  availableFrom?: string;
  availableTo?: string;
  header?: string;
  subHeader?: string;
  appExclusive?: boolean;
  disableProductLink?: boolean;
  cta?: { link: string }[];
  released?: boolean;
} & React.ComponentProps<'li'>;

type LaunchCalendarListProps = {
  items: LaunchCalendarItem[];
  title?: string;
  itemListId?: string;
  itemlistName?: string;
};

export const LaunchCalendarList = (props: LaunchCalendarListProps) => {
  const itemListId = props.itemListId || '';
  const itemListName = props.itemlistName || '';

  // To differentiate in which LaunchCalendarList the click occurred.
  const setIsProductClicked = useProductClickHandling();

  return (
    <Stack gap="sm">
      <Heading transform="uppercase" asChild>
        <h3>{props.title}</h3>
      </Heading>
      <Grid columns={{ initial: 1, tablet: 2, desktop: 4 }} asChild>
        <ul onClick={() => setIsProductClicked(true)}>
          {props.items.map((item, idx) => {
            return (
              <LaunchCalendarTile
                item={item}
                key={idx}
                position={idx}
                itemListId={itemListId}
                itemListName={itemListName}
              />
            );
          })}
        </ul>
      </Grid>
    </Stack>
  );
};
